'use strict';
angular
    .module('dnapp')
    .controller('DN.SearchController', ['DN.InternalSearchService', '$filter', function (dataService, $filter) {
        var ctrl = this;
        var internal = {};

        // Internal variables
        var nodeId = 0;
        var searchterm = '';

        // Public variables
        ctrl.results = [];
        ctrl.contexts = [];
        ctrl.totalResults = 0;
        ctrl.sortOrders = ['Kontekst', 'A-Z', 'Z-A'];
        ctrl.currentSort = 0;
        ctrl.initialLoad = true;

        // Public functions
        ctrl.init = function (vNodeId, vSearchTerm, vTotalResults, vAllContexts) {
            nodeId = vNodeId;
            searchterm = vSearchTerm;
            ctrl.totalResults = vTotalResults;
            ctrl.contexts = vAllContexts;
            internal.pushState();
        }

        ctrl.contextChange = function (contextId) {
            if (ctrl.doesContextExist(contextId)) {
                ctrl.removeContext(contextId);
            } else {
                ctrl.addContext(contextId);
            }
            internal.pushState();
        }

        ctrl.addContext = function (contextId) {
            var result = $filter('filter')(ctrl.contexts, { Id: contextId })[0];
            result.IsSelected = true;
            internal.pushState();
            internal.getItems();
        }

        ctrl.removeContext = function (contextId) {
            var result = $filter('filter')(ctrl.contexts, { Id: contextId })[0];
            result.IsSelected = false;
            internal.pushState();
            internal.getItems();
        }

        ctrl.doesContextExist = function (contextId) {
            return ($filter('filter')(ctrl.contexts, { Id: contextId, IsSelected: true })).length;
        }

        ctrl.setSort = function (sortCode) {
            ctrl.currentSort = sortCode;
            internal.pushState();
            internal.getItems();
        }

        ctrl.getAllSelectedContexts = function () {
            var result = ($filter('filter')(ctrl.contexts, { IsSelected: true })).map(function (cat) { return cat.Name });

            var joined = 'alle';

            if (result.length < ctrl.contexts.length) {
                joined = result.length;
            }

            if (result.length === 0) {
                joined = 'alle';
            }

            return joined;
        }

        ctrl.getAllSelectedContextsForUrl = function() {
            return ($filter('filter')(ctrl.contexts, { IsSelected: true }))
                .map(function (cat) { return cat.Id }).join(',');
        }

        // Internal functions
        internal.pushState = function () {
            window.history.pushState('', '', "?id=" + nodeId + "&search=" + searchterm + "&contexts=" + ctrl.getAllSelectedContextsForUrl() + "&sort=" + ctrl.currentSort);
        }

        internal.getItems = function () {
            var data = {
                q: searchterm,
                nodeId: nodeId,
                contexts: ctrl.getAllSelectedContextsForUrl().split(','),
                sortOrder: ctrl.currentSort
            }

            dataService.Search(data)
                .$promise.then(function (response) {
                    console.log(response);
                    if (response.Success) {
                        ctrl.results = response.Data;
                        ctrl.totalResults = ctrl.results.length;
                        ctrl.initialLoad = false;
                    } else {
                        console.log(response.Error);
                    }
                });
        }
    }]);